import React from 'react'
import clsx from 'clsx'
import { AnimatedShinyText } from '~/src/components/ui/animated-shiny-text'
import useCycleLoaderText from '~/src/hooks/useCycleLoaderText'
import Typewriter from '~/src/components/Typewriter'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  phrases: string[]
  interval?: number
  continuous?: boolean
  shinyText?: boolean
  typewriter?: boolean
  startDelay?: number
}

const CyclePhrases: React.FC<Props> = ({
  phrases,
  className,
  interval,
  continuous,
  shinyText,
  typewriter,
  startDelay = 0,
  ...props
}) => {
  const { fade, currentText } = useCycleLoaderText(phrases, {
    interval,
    continuous,
    startDelay,
  })

  return (
    <div
      className={clsx(
        `transition-opacity duration-500 ${fade} line-clamp-2`,
        className
      )}
      {...props}
    >
      {shinyText ? (
        <AnimatedShinyText>{currentText}</AnimatedShinyText>
      ) : typewriter ? (
        <Typewriter>{currentText}</Typewriter>
      ) : (
        currentText
      )}
    </div>
  )
}

export default React.memo(CyclePhrases)
